import { Box, Grid2 } from "@mui/material";
import React from "react";

import WorkerDetailsCard from "../worker-details-card";
import WorkerShiftsDisplay from "../worker-shifts-display";
//import WorkerShiftsDisplay from "./worker-shifts-display";

interface WorkerShift {
	workerId: string;
	primaryJobName: string;
	workerName: string;
	firstName: string;
	lastName: string;
	companyEmployeeId: string;
  badgeNumber?: string;
	workerTypeId: string;
	workerSubTypeId: string;
	shifts: ShiftCard[];
	dPrimaryJobId: number;
	dwCenterId: number;
	uPrimaryJobId: number;
	shiftId: string;
	shiftPatternName: string;
	shiftWorkcenter: string;
	shiftPrimaryJob: string;
	startDateTime: string;
	endDateTime: string;
	schedulingStatusId: number;
	previousSchedulingStatus?: string;
	isOverTimeShift?: boolean;
	isFlexShift?: boolean;
	isSameWorkcenter?: boolean;
	isSamePrimaryJob?: boolean;
	jobWorkcenters: {
		jobId: number;
		workCenterId: number;
		jobName: string;
		workCenterName: string;
	}[];
  patternId: number;
  isWorkcenterChanged?: boolean;
  isJobChanged?: boolean;
  isPatternChanged?: boolean;
}

interface ShiftCard {
	uwCenterId: any;
	isFlexShift: boolean | undefined;
	shiftId: string;
	startDateTime: string;
	endDateTime: string;
	workcenterId: number;
	dwCenterId: number;
	workerId?: string;
	uPrimaryJobId: number;
	jobId: number;
	schedulingStatusId: number;
	previousSchedulingStatus?: string;
	uPatternId: number;
}

interface WorkerRowProps {
	workers: WorkerShift[];
  isPrinting?: boolean;
}
const BORDER_COLOR = "#E5E5E5";

const WorkerRow = React.memo<WorkerRowProps>(({
                                                workers,
  isPrinting = false,
}) => (
	<>
		{workers.map((worker) => (
			<Grid2
				container
				width="100%"
				key={worker.workerId}
				sx={{
					borderBottom: isPrinting ? "none" : `1px solid ${BORDER_COLOR}`,
          flexWrap: "nowrap",
          height: isPrinting ? "auto" : "100%",
          minHeight: isPrinting ? "unset" : "80px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignSelf: "flex-start",
            width: isPrinting ? "50%" : "210px",
            minWidth: "210px",
					}}
				>
					<WorkerDetailsCard
						workerName={
							worker.firstName + " " + worker.lastName || worker.workerName
						}
						workerId={worker.badgeNumber ? worker.badgeNumber : worker.companyEmployeeId}
						workerTypeId={worker.workerTypeId}
						workerSubTypeId={worker.workerSubTypeId}
            isPrinting={isPrinting}
            isJobChanged={worker.isJobChanged}
            isWorkCenterChanged={worker.isWorkcenterChanged}
            isShiftPatternChanged={worker.isPatternChanged}
					/>
				</Box>
				<WorkerShiftsDisplay worker={worker} isPrinting={isPrinting} />
			</Grid2>
		))}
	</>
));

WorkerRow.displayName = "WorkerRow";

export default WorkerRow;
